import React, { useState, useEffect } from 'react';

/**
 * A observação de quem cobra: "vai pagar dia 15", "espera vender os bezerros".
 *
 * É conversa interna sobre o recebimento e nunca vai para documento do
 * cliente — para o que vai no papel existe a observação do faturamento.
 *
 * Mora no lugar onde já se olha: embaixo da linha do serviço no Financeiro e
 * dentro do financeiro do serviço. Na linha, só aparece quando existe (anotar
 * uma nova é pelo ⋯, para não pôr um "+ observação" em cada serviço); no
 * modal, o convite para anotar fica sempre à vista.
 *
 * Salvar vazio apaga a observação.
 */
const ObservacaoDeCobranca = ({
  valor,
  podeMexer = false,
  onSalvar,
  // A linha abre já editando quando a pessoa escolhe "Anotar" no ⋯.
  editandoDeInicio = false,
  onFimDaEdicao,
  variante = 'linha',
}) => {
  const [editando, setEditando] = useState(editandoDeInicio);
  const [texto, setTexto] = useState(valor || '');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => { if (editandoDeInicio) setEditando(true); }, [editandoDeInicio]);
  useEffect(() => { if (!editando) setTexto(valor || ''); }, [valor, editando]);

  const fechar = () => { setEditando(false); setTexto(valor || ''); onFimDaEdicao?.(); };

  const salvar = async () => {
    setSalvando(true);
    const ok = await onSalvar?.(texto);
    setSalvando(false);
    if (ok !== false) { setEditando(false); onFimDaEdicao?.(); }
  };

  if (editando && podeMexer) {
    return (
      <div className="flex flex-wrap items-center gap-2 mt-2">
        <input
          type="text"
          autoFocus
          maxLength={300}
          value={texto}
          placeholder="Ex.: vai pagar dia 15"
          onChange={(e) => setTexto(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); salvar(); }
            if (e.key === 'Escape') { e.stopPropagation(); fechar(); }
          }}
          aria-label="Observação de cobrança"
          className="flex-1 min-w-[12rem] px-2 py-1 text-sm border border-slate-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button onClick={salvar} disabled={salvando}
          className="px-3 py-1 rounded text-xs font-medium bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50">
          {salvando ? 'Salvando...' : 'Salvar'}
        </button>
        <button onClick={fechar} disabled={salvando}
          className="px-3 py-1 rounded text-xs font-medium bg-white text-slate-700 border border-slate-300 hover:bg-slate-50 disabled:opacity-50">
          Cancelar
        </button>
      </div>
    );
  }

  if (valor) {
    const conteudo = (
      <>
        <span className="font-medium text-slate-700">Obs.:</span> {valor}
      </>
    );
    return podeMexer ? (
      <button onClick={() => setEditando(true)} title="Editar a observação"
        className="block mt-2 text-left text-sm text-slate-600 hover:underline">
        {conteudo}
      </button>
    ) : (
      <p className="mt-2 text-sm text-slate-600">{conteudo}</p>
    );
  }

  if (variante === 'bloco' && podeMexer) {
    return (
      <button onClick={() => setEditando(true)}
        className="text-xs text-blue-600 hover:underline">
        + Observação de cobrança (ex.: vai pagar dia 15)
      </button>
    );
  }

  return null;
};

export default ObservacaoDeCobranca;
